import styled from "@emotion/styled"

// A collapsible section header that matches SettingsOrganizationConfig's look.
export const SectionHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 0;
  cursor: pointer;
`

export const SectionTitleText = styled.div`
  font-size: 16px;
  color: #2d3748;
`

export const SectionContent = styled.div`
  overflow: ${(props) => (props.isOpen ? "visible" : "hidden")};
  max-height: ${(props) => (props.isOpen ? "none" : "0")};
  opacity: ${(props) => (props.isOpen ? 1 : 0)};
  transition: opacity 0.2s ease-in-out;
`

export const ConflictBanner = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  background: #fff7ed;
  border: 1px solid #fed7aa;
  color: #9a3412;
  border-radius: 6px;
  padding: 10px 12px;
  font-size: 13px;
  margin: 8px 0;
`

export const InlineError = styled.div`
  color: ${(props) => props.theme.dangerText};
  background: #fef2f2;
  border: 1px solid #fecaca;
  border-radius: 6px;
  padding: 8px 10px;
  font-size: 12px;
  margin-top: 8px;
  white-space: pre-wrap;
  word-break: break-word;
`

export const HookList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

export const HookCard = styled.div`
  border: 1px solid ${(props) => props.theme.colors.gray1};
  border-radius: 8px;
  background: #ffffff;
`

export const HookSummary = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 14px;
  cursor: pointer;
`

export const HookSummaryMain = styled.div`
  flex: 1;
  min-width: 0;
`

export const HookName = styled.div`
  font-size: 14px;
  color: ${(props) => props.theme.colors.gray9};
  font-weight: 500;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

export const HookMeta = styled.div`
  font-size: 12px;
  color: ${(props) => props.theme.colors.gray6};
  margin-top: 2px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

export const HookEditorBody = styled.div`
  padding: 0 14px 14px 14px;
  display: flex;
  flex-direction: column;
  gap: 4px;
`

export const FieldRow = styled.div`
  display: flex;
  padding-top: 16px;
  gap: 16px;

  > * {
    flex: 1;
  }
`

export const EditorToolbar = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-top: 8px;
`

export const ReadOnlyNotice = styled.div`
  font-size: 12px;
  color: ${(props) => props.theme.colors.gray6};
  font-style: italic;
`

export const HelpPanel = styled.div`
  border: 1px solid ${(props) => props.theme.colors.gray1};
  border-radius: 8px;
  background: ${(props) => props.theme.colors.gray0};
  padding: 12px 14px;
  font-size: 13px;
  color: ${(props) => props.theme.colors.gray9};

  ul {
    margin: 8px 0;
    padding-left: 18px;
  }

  li {
    margin: 4px 0;
  }

  code {
    background: #eef2f7;
    border-radius: 3px;
    padding: 1px 4px;
    font-size: 12px;
  }
`

export const CodeSnippet = styled.pre`
  background: #0b1021;
  color: #d6e2f0;
  border-radius: 6px;
  padding: 10px 12px;
  font-size: 12px;
  overflow-x: auto;
  white-space: pre;
`

// --- App config (allowlist) ---

export const HostList = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin: 8px 0;
`

export const HostChip = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: ${(props) => props.theme.colors.gray0};
  border: 1px solid ${(props) => props.theme.colors.gray1};
  border-radius: 16px;
  padding: 4px 10px;
  font-size: 12px;
  color: ${(props) => props.theme.colors.gray9};

  .remove {
    cursor: pointer;
    color: ${(props) => props.theme.colors.gray6};
  }
  .remove:hover {
    color: ${(props) => props.theme.dangerText};
  }
`

export const AddHostRow = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 8px;

  > .input {
    flex: 1;
  }
`

// --- Channel attachment panel ---

export const ChannelPanel = styled.div`
  padding: 4px 8px 12px 8px;
  display: flex;
  flex-direction: column;
  gap: 8px;
`

export const DragItem = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  border: 1px solid ${(props) => (props.isBroken ? props.theme.dangerText : props.theme.colors.gray1)};
  border-radius: 6px;
  background: ${(props) => (props.isDragging ? props.theme.colors.gray0 : "#ffffff")};
  padding: 8px 10px;
  font-size: 13px;
`

export const DragHandle = styled.span`
  cursor: grab;
  color: ${(props) => props.theme.colors.gray5};
  font-size: 14px;
  user-select: none;
`

export const DragItemMain = styled.div`
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

export const EmptyState = styled.div`
  font-size: 12px;
  color: ${(props) => props.theme.colors.gray6};
  padding: 8px 0;
`

export const PanelActions = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
`
